module.exports = "pegasus_template/assets/themelp1/product/104.png";